import React from 'react';
import { observer } from 'mobx-react-lite';

import { EMOJI_LIST } from 'widget/consts/emoji';
import { useEmojiStore } from 'widget/hooks/useEmojiStore';

import EmojiPickerItem from './EmojiPickerItem';
import styles from './EmojiPicker.module.scss';

export type EmojiPickerProps = {
  onEmojiSelect: (emoji: string) => void;
};

const EmojiPicker: React.FC<EmojiPickerProps> = ({ onEmojiSelect }) => {
  const emojiStore = useEmojiStore();

  React.useEffect(() => {
    return emojiStore.preloadInBatches({ emojiList: EMOJI_LIST });
  }, [emojiStore]);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      const emoji = event.currentTarget.dataset.emoji;
      if (emoji) {
        onEmojiSelect(emoji);
      }
    },
    [onEmojiSelect]
  );

  const handleMouseDown = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
    },
    []
  );

  return (
    <div className={styles['picker']}>
      <div className={styles['picker__grid']}>
        {EMOJI_LIST.map((emoji) => (
          <EmojiPickerItem
            key={emoji}
            emoji={emoji}
            isLoaded={emojiStore.isImageLoaded(emoji)}
            onClick={handleClick}
            onMouseDown={handleMouseDown}
          />
        ))}
      </div>
    </div>
  );
};

export default observer(EmojiPicker);
